import React, { useContext, useEffect, useState } from "react";
import { ActivityType } from "./ActiviltyIcons/ActivityType";
import { Bookmark3 } from "../../icons/Bookmarks3";
import { Bookmark } from "./BookMarkIcons/Bookmark";
import {
  calculateDistance,
  getTodaysStartHour,
  TrancateSent,
  getMon_Date,
  updateQueryParams,
  sendAnalyticsToGA,
} from "../../utils/commanFunctions";
import { useNavigate } from "react-router";
import { GlobalContext } from "../../GlobalProvider";
import { getIconForPlace } from "./GetIconForTab";
import LearnMore from "../Description/LearnMore";
import configs from "../../contentConfig";
import { Date, } from "./Date";
import HeartIcon from "../../icons/HeartIcon";
import ImageComponent from "../Trip/ImageComponent";
import { trackWidgetClick } from "../../utils/FunctionsForGa";


const SubComponent = configs["singleNewCardSubComponet"]["component"]
const isDisableTrancate = configs["singleNewCardSubComponet"]["disableEvnetNameTrancate"]

const SingleCardNew = ({
  data = {},
  size,
  variant = "",
  handleClick,
  boxHeight,
  type = "",
  showBookMark = true,
  handleCloseLoc,
  subLayout = "v1",
  groupData={},
  parentClassSelector=""
}) => {
  

  const { setHotelData, hotelData } = useContext(GlobalContext);
  const reservation_id = localStorage.getItem("reservation_id");
  const isBookmarked = () => {
  const bookMData = JSON.parse(localStorage.getItem("tripBookmarked")) || { ids: [] };
  return bookMData.ids.includes(data.id);
};

  const altImag = `https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain`;
  const imageUrl = data?.images?.length > 0 ? data.images[0].image : altImag;
  let opningStatus = data.openingHours
    ? getTodaysStartHour(data.openingHours)
    : "";

    const imageFocalPoint = data?.images?.[0]?.image_metadata?.focus_point
  const isMap = variant === "map";

  const [distance, setDistance] = useState("");
  const navigate = useNavigate();

const selectedFilter = JSON.parse(localStorage.getItem("selectedFilter"))
 const handleGA = ()=>{
     if(process.env.REACT_APP_GA_ENABLED==="true"){
       const ga_payload = {
         action: selectedFilter,
         type: data?.type,
         widget_name:data?.name,
         isFavorite: isBookmarked(),
       }
   
       trackWidgetClick(ga_payload)
     }
    }

  useEffect(() => {
    const fetchDistance = async () => {
      try {
        const { status, data: distanceData } = await calculateDistance(
          [data.latitude, data.longitude],
          "miles",
          hotelData
        );
        if (status) setDistance(distanceData);
      } catch (error) {
        console.error("Error fetching distance:", error);
      }
    };

    if (type !== "EVENT" && data.latitude && data.longitude) {
      fetchDistance();
    }
  }, [data.latitude, data.longitude]);

  const handleRedirect = (e) => {
    // const path = `/?path=description&ID=${data.id}`

    const currentPath = window.location.href;
  if (currentPath.includes("path=personalizedStayPage")) {
    sessionStorage.setItem("fromPersonalized", "true");
  }
    const path = updateQueryParams({
      path: "description",
      ID: data.id,
    });
    navigate(path);
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        handleGA()
        if (handleClick) handleClick(data);
        else handleRedirect();
      }}
      className={`${parentClassSelector} flex single-card-container max-[500px]:min-w-[auto] max-[500px]:w-full max-[765px]:min-w-[230px] min-w-[355px] cursor-pointer flex-col ${
        size === "full" ? "w-[100%]" : "min-w-60"
      } items-start ${isMap ? "" : "gap-2"} relative`}
      style={{
        background: isMap ? "white" : "transparent",
        borderRadius: isMap ? "12px" : "0px",
        // ...(!isMap ? { height: boxHeight || "212px" } : { overflow: "hidden" }),
        ...(!isMap
          ? {
              height:
                size === "large"
                  ? "431px"
                  : size === "small"
                  ? "212px"
                  : boxHeight || "412px",
            }
          : { overflow: "hidden" }),
      }}
    >
      <div
        // style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
        className={`single-card-cont relative flex-1 self-stretch w-full grow overflow-hidden bg-cover bg-[50%_50%] ${
          // size === "small" ? "min-h-[170px] max-h-[170px]" : "min-h-[145px]"
          size === "small"
            ? "min-h-[164px] max-h-[164px]"
            : size === "large"
            ? "min-h-[330px] max-h-[330px]"
            : "min-h-[145px]"
        }`}
      >
        <ImageComponent imageUrl={imageUrl} focalPoint={imageFocalPoint} passedClasses={'single-card-new-image object-cover'} />
             {/* <img 
          src={imageUrl}
          alt={data.name || "Place image"}
          loading="lazy"
          className="w-full h-full object-cover"
        /> */}
        {/* {size !== "large" && ( */}
          <ActivityType
            className="!absolute !left-2 bottom-2 icon-css "
            variant="default"
            text={data?.display_category?.label}
            Icon={getIconForPlace(data?.display_category?.value, "active")}
          />
        {/* )} */}

        {/* {size == "large" && (
          <div className="large-bottom">
          <LearnMore />
        </div>
        
        )} */}

        {/* {showBookMark && size !== "large" && ( */}
          <Bookmark
            className={
              isMap
                ? `!p-1.5 icon-on-card !absolute right-[44px] !top-[8px] rounded-md bg-[#00000080] cursor-pointer`
                : `!p-1.5 icon-on-card !absolute right-[8px] !top-[8px] rounded-md bg-[#00000080] cursor-pointer`
            }
            icon={<HeartIcon className="!relative !w-4 !h-4 bookmark-icon" />}
            stateProp="default"
            id={data.id}
            name={data.name}
            isBookmarked={isBookmarked}
          />
        {/* )} */}
        {data?.start_time && (
          <Date
          
            position="!p-1.5 !absolute left-[8px] !top-[8px] rounded-md bg-[#00000080]"
            data={getMon_Date(data.start_time)}
          />
        )}

        {isMap && (
          <div
            className={`inline-flex items-center gap-1 px-2 py-1.5 overflow-hidden relative !p-1.5 !absolute right-[8px] !top-[8px] rounded-md bg-[#00000080] cursor-pointer`}
            onClick={(e) => {
              e?.stopPropagation();
              handleCloseLoc();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g id="x">
                <path
                  id="Vector"
                  d="M12 4L4 12M4 4L12 12"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </svg>
          </div>
        )}
      </div>

      <div
        className={`flex flex-col items-start gap-1 self-stretch w-full relative flex-[0_0_auto] cards-bottom-info  ${
          isMap ? "p-4" : ""
        }`}
      >
        <p className="font-bold relative self-stretch h-[18px] mt-[-1.00px] font-secondary text-[#333333] text-base tracking-[0] leading-[normal] [display:-webkit-box] [-webkit-line-clamp:0] [-webkit-box-orient:vertical] event-name">
          {
          !isDisableTrancate ?  size !== "full"
            ? TrancateSent(data.name)
            : TrancateSent(data.name, 40):data.name
          }
        </p>
<SubComponent groupData={groupData} data={data} distance={distance} opningStatus={opningStatus} subLayout={subLayout}/>
      </div>
    </div>
  );
};

export default SingleCardNew;
